/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportTransactionRequest { 
    type: ReportTransactionRequest.TypeEnum;
    description?: string;
}
export namespace ReportTransactionRequest {
    export type TypeEnum = 'WRONG_POINTS' | 'WRONG_COMPANY' | 'WRONG_INVOICE_NO' | 'WRONG_DATE_TIME' | 'WRONG_DATA' | 'UNKNOWN_ERROR';
    export const TypeEnum = {
        WrongPoints: 'WRONG_POINTS' as TypeEnum,
        WrongCompany: 'WRONG_COMPANY' as TypeEnum,
        WrongInvoiceNo: 'WRONG_INVOICE_NO' as TypeEnum,
        WrongDateTime: 'WRONG_DATE_TIME' as TypeEnum,
        WrongData: 'WRONG_DATA' as TypeEnum,
        UnknownError: 'UNKNOWN_ERROR' as TypeEnum
    };
}


